// extracted by mini-css-extract-plugin
export var filterIncDec = "_40-0";
export var leftBorder = "_40-1";
export var rightBorder = "_40-2";
export var stringInput = "_40-3";